import { Button, Dialog, Stack, Typography, useTheme } from '@mui/material';
import { CancelToken } from 'apisauce';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalHeader from '../../../../components/ModalHeader';
import FormTextField from '../../../../components/FormTextField';
import { Form, Formik } from 'formik';
import PageHeader from '../../../../components/PageHeader';
import Datatable from '../../../../components/DataTable';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import * as yup from 'yup';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import { useState } from 'react';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import { setLoading } from '../../../../redux/features/appSlice';
import uploadFileToS3 from '../../../../utils/fileUpload';
import { showmessage } from '../../../../utils/toastr';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  // tradeType: yup.string('Trader Type').required(' '),
  // priceType: yup.string('Price Type').required(' '),
  // euaRequired: yup.string('Eua Required').required(' '),
  remarks: yup.string('Remarks').required(' ').min(3).max(300),
  // traderIds: yup.array().of(yup.string()).min(1).required(),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

const columns = [
  {
    id: 0,
    header: '#',
    accessor: 'Sno',
    width: '15%',
  },
  {
    id: 1,
    header: 'Name',
    accessor: 'name',
    width: '40%',
    capitalize: true,
  },
  {
    id: 2,
    header: 'Email',
    accessor: 'email',
    width: '40%',
  },
];

export default function SendReportToContact({ modelOpen, onModelHandleClose, voyageId }) {
  const formRef = useRef();
  const theme = useTheme();

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    companyTypeFilter: [],
    field: '_id',
    sortOrder: 'desc',
  });

  const { user, companyDetails } = useSelector((state) => state.auth);
  const [tradeList, setTradeList] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState(null);
  const [contactList, setContactsList] = useState([]);
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);

  let source = CancelToken.source();
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetContacts = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/contact-management/all/companyContacts`,
      {
        pageNumber: payload.page,
        filter: payload.filter || null,
        pageSize: payload.limit,
        companyTypeFilter: payload.companyTypeFilter,
        sortOrderField: payload.field === 'companyName' ? 'sortCompanyName' : payload.field === 'name' ? 'sortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          item.isSelected = false;
          return item;
        });
        setContactsList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setContactsList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setContactsList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetContacts();
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder, payload.companyTypeFilter]);

  const handleFile = (file) => {
    if (file?.path) {
      formRef?.current?.setFieldValue('voyageReport', file);
    } else {
      formRef?.current?.setFieldValue('voyageReport', undefined);
    }
  };

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    const companies = [...selectedCompanyIds];
    const ids = companies.map((res) => res._id);
    if (checkedStatus) {
      companies.push(item);
    } else {
      const index = ids.indexOf(item._id);
      if (index != -1) {
        companies.splice(index, 1);
      }
    }
    setSelectedCompanyIds(companies);
  };

  useEffect(() => {
    if (selectedCompanyIds.length > 0) {
      const items = contactList.map((res) => {
        return {
          ...res,
          isSelected: selectedCompanyIds.map((res) => res._id).includes(res._id),
        };
      });
      setIsAllChecked(selectedCompanyIds.length === items.length)
      setContactsList(items);
    } else {
      const items = contactList.map((res) => {
        return {
          ...res,
          isSelected: false,
        };
      });
      setContactsList(items);
      setIsAllChecked(false)
    }
  }, [selectedCompanyIds]);

  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  const handleSendReport = async (values) => {
    dispatch(setLoading(true));
    if (values.voyageReport && values.voyageReport?.path) {
      try {
        values['voyageReport'] = await uploadFileToS3(values?.voyageReport);
      } catch (e) {}
    }
    const payload = {
      contactId: selectedCompanyIds.map((res) => {
        return res._id;
      }),
      companyId: user?.companyId,
      voyageId: voyageId,
      ...values,
    };
    const response = await appapi.post(`/fleet/verifiedReportSendToContact`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <ModalHeader
          label={t('Send report to contacts')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            remarks: '',
            voyageReport: '',
            // traderIds: selectedTraders,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSendReport(values);
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue, setFieldTouched }) => (
            <Form
              className="flex flex-col flex-1"
              autoComplete="off"
            >
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Details')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack className="!mb-[16px]">
                  <FileUploadField
                    placeholder={t('Upload File (Upload csv or xlsx file)')}
                    url={values?.voyageReport ? values?.voyageReport : null}
                    inputId={`doc`}
                    handleFile={(files) => handleFile(files)}
                    showFileName={false}
                    bgColor={'#14285A1A'}
                    enableExcel={true}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Remark')}
                    name="remarks"
                    multiline={true}
                    maxRows={3}
                    requiredMark={true}
                    inputProps={{ maxLength: 301 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        minHeight: '88px !important',
                        display: 'block',
                      },
                    }}
                  />
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px]"
              >
                <PageHeader
                  tableType={'2'}
                  headerColor={'#F2F3F580'}
                  showCloseBtn={true}
                  //   handleClose={handleClose}
                  handleOnSearchEmit={(search) => {
                    handleSearchEmit(search);
                  }}
                >
                  <Stack direction="row">
                    <Stack style={{ paddingLeft: '10px' }}>
                      <Typography
                        className="fs-16 ff-Roboto fw-regular !capitalize"
                        color={'#14285A'}
                      >
                        {t('Select contacts')}
                      </Typography>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={'#8993AC'}
                      >
                        {t('Select contacts to send report')}
                      </Typography>
                    </Stack>
                  </Stack>
                </PageHeader>
                <Datatable
                  tableHeadBgColor={'rgb(243 244 247)'}
                  columns={columns}
                  data={contactList || []}
                  isLoading={isloading}
                  showCheckBox={true}
                  onChangeCheckBox={handleOnChangeCheckBox}
                  onAllSelectCheckBox={(checkedStatus) => {
                    const arr = contactList.map((res) => {
                      return {
                        ...res,
                        isSelected: checkedStatus,
                      };
                    });
                    setSelectedCompanyIds(checkedStatus ? arr : []);
                  }}
                  isAllChecked={isAllChecked}
                />
              </Stack>
              
              <Stack
                direction="row"
                justifyContent="flex-end"
                className="px-4 py-2 !justify-end p-[0px] sticky bottom-[0] !mt-[32px]"
                // className="!mt-[44px] h-[66px] "
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      backgroundColor: theme.palette.primary.dark,
                      textTransform: 'uppercase',
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid) || selectedCompanyIds.length === 0}
                  type="submit"
                  variant="contained"
                >
                  {t('Send')}
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
